import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { ContractOffers, ContractOffersStruct } from "../../models/contract-offers/contract-offers";
import { ListContracts, ListContractStruct } from "../../models";

@Injectable()
export class TenderBidAnalysisReportService {
    public totalPageItems: number;

    constructor(
        private http: HttpClient
    ) {
    }

    public fetch(tenderId: string, page: number = 1, itemsPerPage = 10, locationTagFilter: number[] = [], search: string = '', supplierFilter: number[] = [], brandedFilter: boolean | null = null, companyFilter: string[] = []) {
        let limit = itemsPerPage;
        let offset = 0;

        if (page > 1){
            offset = (page - 1) * limit
        }
        let params: any = {
            'limit': limit,
            'offset': offset,
            'page_num': page
        };

        // Add location tag filter if provided
        if (locationTagFilter && locationTagFilter.length > 0) {
            params['location_tag_filter'] = locationTagFilter.join(',');
        }

        if (search) {
            params['search'] = search;
        }

        if (supplierFilter && supplierFilter.length > 0) {
            params['supplier_filter'] = supplierFilter.join(',');
        }

        if (brandedFilter !== null) {
            params['branded_filter'] = brandedFilter.toString();
        }

        if (companyFilter && companyFilter.length > 0) {
            params['company_filter'] = companyFilter.join('|');
        }

        return this.http.get(`${environment.apiUrl}/v2/buyer/tenders/${tenderId}/analysis-report/?page=${page}`, {params: params})
          .pipe(map((data: ContractOffersStruct[]) => {
              this.totalPageItems = data['count'];
            return data['results'].map((item) => ContractOffers.create(item));
          }));
    }

    public getPdf(tenderId: string, locationTagFilter?: string, search: string = '', supplierFilter: number[] = [], brandedFilter: boolean | null = null, companyFilter: string[] = []) {
        let params: any = {};
        if (locationTagFilter) {
            params.location_tag_filter = locationTagFilter;
        }
        if (search) {
            params.search = search;
        }
        if (supplierFilter && supplierFilter.length > 0) {
            params.supplier_filter = supplierFilter.join(',');
        }
        if (brandedFilter !== null) {
            params.branded_filter = brandedFilter.toString();
        }
        if (companyFilter && companyFilter.length > 0) {
            params.company_filter = companyFilter.join('|');
        }
        params.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.http.get(`${environment.apiUrl}/v2/buyer/tenders/${tenderId}/analysis-report/export/pdf/`,
            {responseType: 'blob', params: params})
    }

    public getPdfDelayed(tenderId: string, locationTagFilter?: string, search: string = '', supplierFilter: number[] = [], brandedFilter: boolean | null = null, companyFilter: string[] = []) {
        let params: any = {};
        if (locationTagFilter) {
            params.location_tag_filter = locationTagFilter;
        }
        if (search) {
            params.search = search;
        }
        if (supplierFilter && supplierFilter.length > 0) {
            params.supplier_filter = supplierFilter.join(',');
        }
        if (brandedFilter !== null) {
            params.branded_filter = brandedFilter.toString();
        }
        if (companyFilter && companyFilter.length > 0) {
            params.company_filter = companyFilter.join('|');
        }
        params.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.http.post(`${environment.apiUrl}/v2/buyer/tenders/${tenderId}/analysis-report/export/pdf/status/delayed/`, {}, {params: params})
          .pipe();
    }

    public getFeePdf(tenderId: string, locationTagFilter?: string, search: string = '', supplierFilter: number[] = [], companyFilter: string[] = []) {
        let params: any = {};
        if (locationTagFilter) {
            params.location_tag_filter = locationTagFilter;
        }
        if (search) {
            params.search = search;
        }
        if (supplierFilter && supplierFilter.length > 0) {
            params.supplier_filter = supplierFilter.join(',');
        }
        if (companyFilter && companyFilter.length > 0) {
            params.company_filter = companyFilter.join('|');
        }
        params.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.http.get(`${environment.apiUrl}/v2/buyer/tenders/${tenderId}/analysis-fee-report/export/pdf/`,
            {responseType: 'blob', params: params})
    }

    public getPdfFeeDelayed(tenderId: string, locationTagFilter?: string, search: string = '', supplierFilter: number[] = [], companyFilter: string[] = []) {
        let params: any = {};
        if (locationTagFilter) {
            params.location_tag_filter = locationTagFilter;
        }
        if (search) {
            params.search = search;
        }
        if (supplierFilter && supplierFilter.length > 0) {
            params.supplier_filter = supplierFilter.join(',');
        }
        if (companyFilter && companyFilter.length > 0) {
            params.company_filter = companyFilter.join('|');
        }
        params.tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return this.http.post(`${environment.apiUrl}/v2/buyer/tenders/${tenderId}/analysis-fee-report/export/pdf/status/delayed/`, {}, {params: params})
          .pipe();
    }

    public fetchCompanyOptions(tenderId: string) {
        return this.http.get(`${environment.apiUrl}/v2/buyer/tenders/${tenderId}/contracts-list/`)
          .pipe(map((data: any) => {
              const rows = Array.isArray(data) ? data : (data.results || data.contracts || []);
              const contracts = rows.map((item: ListContractStruct) => ListContracts.create(item));
              const unique = new Set<string>();
              contracts.forEach((c: any) => {
                  if (c.companyChild && c.companyChild.name) {
                      unique.add(c.companyChild.getDisplayName());
                  } else if (c.companyInfo && c.companyInfo.trim()) {
                      unique.add(c.companyInfo.trim());
                  }
              });
              return Array.from(unique)
                  .sort((a, b) => a.localeCompare(b))
                  .map((name) => ({ name, value: name }));
          }));
    }

    public getTotalPageItems() {
        return this.totalPageItems;
    }
}
